import { ProgramType } from "shared/enums/ProgramType";

export const DashboardProgramTypeClassesMap: { [key in ProgramType]: string } = {
  [ProgramType.MEETUP_PROGRAM]: "isMeetingProgram",
  [ProgramType.IN_PERSON_MEETUP_PROGRAM]: "isMeetingProgram",
  [ProgramType.TABLETALK_PROGRAM]: "isTabletalkProgram",
  [ProgramType.BUYERS_PROGRAM]: "isBuyersProgram",
  [ProgramType.ASSOCIATED_PROGRAM]: "isAssociatedProgram",
  [ProgramType.TRADE_PROGRAM]: "isTradeProgram",
  [ProgramType.CONNECTIONS_PROGRAM]: "isConnectionProgram"
};
